/* AMANA — Panier "rip Qikify" : pilote la structure qsc2-* (HTML/CSS copiés du live Qikify).
   Contenu = snippets/qsc2-cart-content.liquid, rendu dans le tiroir (section qikify-cart) et sur la
   page /cart (section main-cart). Chaque rendu remplace `.qsc2-drawer__content` partout.

   Mutations (2026-09-29) :
   • par CLÉ de ligne (update.js), jamais par position : les cadeaux ajoutés en tête décalaient les
     positions, un clic pendant la synchro pouvait retirer une autre ligne ;
   • cadeaux (window.AmanaGifts, assets/auto-gift.js) calculés AVANT la mutation depuis l'état JSON
     du rendu (`data-qsc-cart`) et appliqués dans la même requête (retrait, quantité) ou juste après
     l'ajout ; la section revient dans la réponse (bundled section rendering) : un seul rendu, sans
     relire /cart.js ni ?sections= ;
   • pendant un ajout, ligne provisoire (image + titre du produit) dans le tiroir au lieu de
     l'ancien contenu. */
(function () {
  'use strict';
  var SECTION = 'qikify-cart';
  function q(sel, root) { return (root || document).querySelector(sel); }
  function drawerEl() { return q('[data-qsc-drawer]'); }
  function overlayEl() { return q('[data-qsc-overlay]'); }
  // Préfixe locale ('/' ou '/de/...') lu sur le contenu rendu : rend les fetches cart/sections localisés
  // (sinon le re-render et les messages d'erreur Shopify reviennent en FR sur /en /es /de).
  function rootUrl() {
    var c = q('[data-qsc-content]');
    var r = (c && c.getAttribute('data-qsc-root')) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  // Libellés traduits injectés par le snippet (blob JSON data-qsc-i18n, clés amana.cart.* des locale files).
  var I18N;
  function i18n(key, fallback) {
    if (!I18N) {
      var el = q('[data-qsc-i18n]');
      try { I18N = el ? JSON.parse(el.textContent) : {}; } catch (e) { I18N = {}; }
    }
    return I18N[key] || fallback;
  }
  // État du panier au dernier rendu (prix en centimes, devise du client).
  function cartState(root) {
    var el = q('[data-qsc-cart]', root);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function gifts() { return window.AmanaGifts || null; }
  function giftVids() { var g = gifts(); return g ? g.giftVariantIds : [49410836627796, 55675544142164]; }
  // Requêtes du panier hors intercepteur d'auto-gift : le plan des cadeaux est appliqué ici.
  function rawFetch(url, opts) { var g = gifts(); return g ? g.fetch(url, opts) : fetch(url, opts); }
  function postJson(path, body) {
    return rawFetch(rootUrl() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  var discountCode = '';
  var copyTimer = null;

  // ---------------------------------------------------------------------------
  // Couche analytics du drawer — UN SEUL point d'émission (track) → destinations pluggables.
  // Stratégie "structure d'abord, câblage ensuite" : GA4 ACTIF ; Meta et Clarity PRÉPARÉS mais OFF.
  // Events émis = ceux que Shopify NE capte PAS (view_cart, select_item, remove_from_cart, share,
  // add_to_wishlist). add_to_cart / view_item / purchase sont déjà émis par le Web Pixel Shopify
  // (vers GA4 ET Meta) → on ne les double JAMAIS ici.
  //
  // POUR CÂBLER META plus tard (une fois CAPI + déduplication event_id validées en interface) :
  //   1) ANALYTICS.meta.enabled = true
  //   2) compléter META_EVENT_MAP (n'émettre QUE les events NON captés par le Web Pixel, sinon double-fire)
  //   3) si la CAPI est active : passer le MÊME event_id côté navigateur et serveur (dédup)
  // POUR CÂBLER CLARITY : ANALYTICS.clarity.enabled = true + ajouter le loader dans theme.liquid.
  // Détails : wiki shopify/cart-drawer § Analytics.
  var ANALYTICS = {
    ga4:     { enabled: true,  id: 'G-45ZR144L2K' },
    meta:    { enabled: false, pixelId: '1469991467035506' }, // le Web Pixel Shopify gère déjà le pixel — câblage différé
    clarity: { enabled: false, projectId: '' }
  };
  var lastViewCart = 0;
  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true; // défaut : laisser le Consent Mode de gtag arbitrer le consentement
  }
  // GA4 (gtag) — ACTIF.
  function sendGA4(name, params) {
    if (!ANALYTICS.ga4.enabled || typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, Object.assign({ send_to: ANALYTICS.ga4.id }, params || {})); } catch (e) {}
  }
  // Meta (fbq) — OFF. Mapping event interne -> event Meta standard (null = ne pas envoyer : déjà
  // couvert par le Web Pixel, ou pas d'équivalent standard). add_to_wishlist = candidat n°1 au câblage.
  var META_EVENT_MAP = {
    view_cart: null, select_item: null, remove_from_cart: null, share: null, add_to_wishlist: 'AddToWishlist'
  };
  function sendMeta(name, params) {
    if (!ANALYTICS.meta.enabled || typeof window.fbq !== 'function') return;
    var ev = META_EVENT_MAP[name];
    if (!ev) return;
    var p = (params && params.value != null) ? { value: params.value, currency: params.currency || 'EUR' } : {};
    try { window.fbq('track', ev, p); } catch (e) {}
  }
  // Microsoft Clarity — OFF. Le session-replay se charge via un snippet (theme.liquid) ;
  // ici on ne fait que tagger les events en "custom tags" quand il sera activé.
  function sendClarity(name) {
    if (!ANALYTICS.clarity.enabled || typeof window.clarity !== 'function') return;
    try { window.clarity('event', name); } catch (e) {}
  }
  // Point d'émission unique appelé partout dans le drawer.
  function track(name, params) {
    if (!canTrack()) return;
    sendGA4(name, params);
    sendMeta(name, params);   // no-op tant que ANALYTICS.meta.enabled = false
    sendClarity(name);        // no-op tant que ANALYTICS.clarity.enabled = false
  }
  function priceFromText(t) { // "€1 234,50" -> 1234.5 ; "Offert" -> 0
    if (!t) return 0;
    var s = String(t).replace(/\s/g, '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }
  function stateItem(key, root) {
    var st = cartState(root);
    if (!st) return null;
    for (var i = 0; i < st.items.length; i++) if (st.items[i].key === key) return st.items[i];
    return null;
  }
  function gaItem(it) { // item GA4 depuis une ligne de l'état JSON
    return { item_id: String(it.variant_id), item_name: it.title, price: it.final_price / 100, quantity: it.quantity };
  }
  function trackViewCart() { // ouverture du drawer ; lit l'état du dernier rendu (plus de /cart.js)
    var now = Date.now();
    if (now - lastViewCart < 600) return; // openDrawer peut être appelé 2x rapprochés
    lastViewCart = now;
    if (!canTrack() || !ANALYTICS.ga4.enabled) return; // view_cart ne concerne que GA4 (pas de mapping Meta)
    var c = cartState(drawerEl());
    if (!c || !c.items || !c.items.length) return;
    var items = c.items.filter(function (it) { return it.final_price > 0; }).map(function (it) {
      var g = gaItem(it);
      if (it.variant_title && it.variant_title !== 'Default Title') g.item_variant = it.variant_title;
      return g;
    });
    track('view_cart', { currency: c.currency || 'EUR', value: c.total_price / 100, items: items });
  }

  function openDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d) return false;
    d.classList.remove('qsc2-drawer--hidden');
    if (o) o.classList.remove('qsc2-overlay--hidden');
    document.body.style.overflow = 'hidden';
    trackViewCart(); // GA4 : ouverture du panier (non capté par Shopify)
    return true;
  }
  function closeDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d) return;
    d.classList.add('qsc2-drawer--hidden');
    if (o) o.classList.add('qsc2-overlay--hidden');
    document.body.style.overflow = '';
  }

  // Remplace le contenu du tiroir et de la page /cart par le HTML de la section (source = notre
  // propre section Shopify, HTML de confiance ; DOMParser n'exécute aucun script).
  function render(html) {
    if (html == null) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-qsc-content]');
    if (!fresh) return false;
    var targets = document.querySelectorAll('[data-qsc-content]');
    for (var i = 0; i < targets.length; i++) {
      targets[i].replaceWith(i === targets.length - 1 ? document.adoptNode(fresh) : fresh.cloneNode(true));
    }
    if (window.AmanaWishlist) window.AmanaWishlist.refresh(); // cœurs favoris du contenu remplacé
    var cnt = doc.querySelector('[data-qsc-count]');
    if (cnt) document.querySelectorAll('[data-header-cart-count],[data-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
    return true;
  }
  function renderFrom(json) { return !!(json && json.sections && render(json.sections[SECTION])); }

  function refresh(cb) {
    rawFetch(rootUrl() + '?sections=' + SECTION, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data[SECTION]); if (cb) cb(); })
      .catch(function () { if (cb) cb(); });
  }

  // Toast d'erreur dans le tiroir (ou la page) : ex. 422 "déjà tous dans votre panier" sur un article
  // à stock 1 — sans feedback, le client croit que le bouton est cassé.
  function qscToast(msg) {
    var d = drawerEl() && !drawerEl().classList.contains('qsc2-drawer--hidden') ? drawerEl() : (q('[data-qsc-page]') || drawerEl());
    if (!d) return;
    var t = d.querySelector('[data-qsc-toast]');
    if (!t) {
      t = document.createElement('div');
      t.setAttribute('data-qsc-toast', '');
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:' + (d === drawerEl() ? 'absolute' : 'fixed') + ';left:12px;right:12px;bottom:14px;z-index:60;background:#2b062b;color:#fff;padding:10px 14px;border-radius:8px;font-size:13px;line-height:1.4;box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transition:opacity .2s;pointer-events:none;max-width:460px;margin:0 auto';
      d.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    clearTimeout(t.__hide);
    t.__hide = setTimeout(function () { t.style.opacity = '0'; }, 3500);
  }
  function toastFromResponse(r, fallback) {
    return r.json().catch(function () { return {}; }).then(function (j) { qscToast(j.description || j.message || fallback); });
  }

  // --- Cadeaux : plan appliqué avec la mutation -----------------------------------------------

  // Projette l'état JSON après la mutation voulue (quantités par clé, lignes ajoutées).
  function projectItems(items, changes, added) {
    var out = [];
    items.forEach(function (it) {
      var c = Object.assign({}, it);
      if (Object.prototype.hasOwnProperty.call(changes || {}, it.key)) {
        var qty = changes[it.key];
        if (qty <= 0) return;
        var unitOrig = it.quantity ? it.original_line_price / it.quantity : it.original_line_price;
        c.quantity = qty; c.final_line_price = it.final_price * qty; c.original_line_price = Math.round(unitOrig * qty);
      }
      out.push(c);
    });
    (added || []).forEach(function (a) {
      var i = -1;
      for (var k = 0; k < out.length; k++) if (out[k].key === a.key) i = k;
      var line = { key: a.key, variant_id: a.variant_id, quantity: a.quantity, final_price: a.final_price, final_line_price: a.final_line_price, original_line_price: a.original_line_price };
      if (i >= 0) out[i] = line; else out.unshift(line);
    });
    return out;
  }

  // Exécute les cadeaux restants après la mutation principale ; rend la dernière réponse.
  // first = réponse JSON de la mutation principale (avec sections) ; cart = JSON panier si connu.
  function finishWithGifts(first, p, cart) {
    var g = gifts();
    var chain = Promise.resolve({ json: first, cart: cart });
    if (p && p.add.length) {
      chain = chain.then(function (prev) {
        return postJson('cart/add.js', { items: p.add, sections: SECTION }).then(function (r) {
          return r.ok ? r.json().then(function (j) { return { json: j, cart: null }; }) : prev;
        });
      });
    }
    if (p && Object.keys(p.updates).length) {
      chain = chain.then(function (prev) {
        return postJson('cart/update.js', { updates: p.updates, sections: SECTION }).then(function (r) {
          return r.ok ? r.json().then(function (j) { return { json: j, cart: j }; }) : prev;
        });
      });
    }
    return chain.then(function (last) {
      if (!renderFrom(last.json)) refresh();
      if (g) g.settled(last.cart);
    });
  }

  // Change les quantités de lignes (clé → quantité) et, dans la même requête, les cadeaux concernés.
  function setLines(changes) {
    var g = gifts(), st = cartState();
    var updates = Object.assign({}, changes);
    var p = null;
    if (g && st) {
      p = g.plan({ items: projectItems(st.items, changes) });
      Object.keys(p.updates).forEach(function (k) { if (!Object.prototype.hasOwnProperty.call(updates, k)) updates[k] = p.updates[k]; });
      p = { add: p.add, updates: {} };
    }
    return postJson('cart/update.js', { updates: updates, sections: SECTION })
      .then(function (r) {
        if (!r.ok) {
          toastFromResponse(r, i18n('toast_unavailable', 'Article indisponible.'));
          refresh();
          if (g) g.sync(); // état local sans doute périmé (autre onglet) : le module cadeaux relit /cart.js
          return;
        }
        return r.json().then(function (j) { return finishWithGifts(j, p, j); });
      })
      .catch(function () { refresh(); });
  }

  // Ajoute des articles (FormData du formulaire produit, ou { items }) puis les cadeaux déclenchés.
  function addToCart(body) {
    var g = gifts(), st = cartState();
    // Rendu demandé dès cette requête, sauf si le panier n'a encore aucun cadeau : le 1er sac en
    // déclenche presque toujours, le rendu viendra avec l'ajout des cadeaux (~150 ms de rendu épargnés).
    var withSections = !g || !st || st.items.some(function (it) { return g.isGift(it); });
    var req;
    if (body instanceof FormData) {
      if (withSections) body.append('sections', SECTION);
      req = rawFetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body });
    } else {
      req = postJson('cart/add.js', withSections ? Object.assign({ sections: SECTION }, body) : body);
    }
    return req.then(function (r) {
      if (!r.ok) {
        toastFromResponse(r, i18n('toast_add_failed', "Impossible d'ajouter cet article.")); // ex. 422 stock épuisé / déjà au panier
        refresh(); // restaure le contenu (ligne provisoire, spinner reco)
        return false;
      }
      return r.json().then(function (j) {
        var added = j.items || (j.key ? [j] : []);
        var p = (g && st) ? g.plan({ items: projectItems(st.items, null, added) }) : null;
        if (!p || p.empty) {
          if (!renderFrom(j)) refresh();
          if (g) g.settled(null);
          return true;
        }
        return finishWithGifts(j, p, null).then(function () { return true; });
      });
    }).catch(function () { refresh(); return false; });
  }

  // Ligne provisoire pendant un ajout : image + titre repris de la carte produit ou de la fiche.
  function productPreview(form) {
    var card = form.closest('.product-item, product-item, [data-product-item], .card-product');
    var img = null, title = '';
    if (card) {
      img = card.querySelector('img');
      var te = card.querySelector('.product-item__title, [class*="title"]');
      title = te ? te.textContent : '';
    } else {
      img = q('.product-gallery-item img, .product-gallery img');
      var h = q('h1');
      title = h ? h.textContent : '';
    }
    return { src: img ? (img.currentSrc || img.src) : '', title: (title || '').replace(/\s+/g, ' ').trim() };
  }
  function showPending(form) {
    var d = drawerEl();
    if (!d) return;
    var body = d.querySelector('[data-qsc-body]');
    if (!body) return;
    var lines = body.querySelector('[data-qsc-lines]');
    if (!lines) {
      while (body.firstChild) body.removeChild(body.firstChild); // état vide remplacé par la liste
      lines = document.createElement('div');
      lines.className = 'qsc2-drawer-rows qsc2-drawer--product-block';
      lines.setAttribute('data-qsc-lines', '');
      body.appendChild(lines);
    }
    var info = productPreview(form);
    var row = document.createElement('div');
    row.className = 'qsc2-product-item-wrapper qsc2-product-item-wrapper--pending';
    row.setAttribute('aria-busy', 'true');
    var item = document.createElement('div'); item.className = 'qsc2-product-item';
    var imgBox = document.createElement('div'); imgBox.className = 'qsc2-product-item__image';
    if (info.src) { var im = document.createElement('img'); im.src = info.src; im.alt = ''; imgBox.appendChild(im); }
    var content = document.createElement('div'); content.className = 'qsc2-product-item__content';
    var tt = document.createElement('div'); tt.className = 'qsc2-product-item__product-title';
    var span = document.createElement('span'); span.textContent = info.title; tt.appendChild(span);
    var sp = document.createElement('span'); sp.className = 'qsc2-spinner qsc2-pending-spinner';
    content.appendChild(tt); content.appendChild(sp);
    item.appendChild(imgBox); item.appendChild(content); row.appendChild(item);
    lines.insertBefore(row, lines.firstChild);
  }

  // Permalink de partage du panier, construit SYNCHRONEMENT depuis l'état du rendu où l'on a cliqué
  // (cadeaux exclus ; ils se recalculent chez le destinataire). storefront=true => arrive au panier.
  // Synchrone = pas d'await => compatible navigator.share (qui exige un "user gesture" non rompu).
  function buildCartLinkSync(root) {
    var st = cartState(root) || { items: [] };
    var gv = giftVids();
    var parts = st.items.filter(function (it) { return gv.indexOf(Number(it.variant_id)) === -1; })
      .map(function (it) { return it.variant_id + ':' + it.quantity; });
    return parts.length ? (location.origin + rootUrl() + 'cart/' + parts.join(',') + '?storefront=true') : (location.origin + rootUrl() + 'cart');
  }

  // Clic sur "Partager mon panier" : feuille de partage native si dispo (mobile), sinon false (=> panneau d'options).
  function shareCart(root) {
    var url = buildCartLinkSync(root);
    if (navigator.share) {
      navigator.share({ title: i18n('share_title', 'Mon panier AMANA'), text: i18n('share_text', 'Découvrez ma sélection AMANA'), url: url })
        .then(function () { track('share', { method: 'native', content_type: 'cart' }); })
        .catch(function () {});
      return true;
    }
    return false;
  }

  // Option de partage explicite (panneau desktop).
  function shareVia(type, labelEl, root) {
    var url = buildCartLinkSync(root);
    var msg = i18n('share_text', 'Découvrez ma sélection AMANA') + ' : ' + url;
    track('share', { method: type, content_type: 'cart' }); // GA4 : partage panier + canal
    if (type === 'whatsapp') window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    else if (type === 'email') window.location.href = 'mailto:?subject=' + encodeURIComponent(i18n('share_title', 'Mon panier AMANA')) + '&body=' + encodeURIComponent(msg);
    else if (type === 'copy') copyText(url, labelEl);
  }

  // Copie robuste : clipboard async + fallback execCommand si la promesse reste pending
  // (Piège HTTPS/strict : .then jamais appelé) ; clearTimeout anti-accumulation du feedback.
  function copyText(text, labelEl) {
    var ORIGINAL = labelEl ? (labelEl.getAttribute('data-orig') || labelEl.textContent) : i18n('copy_link', 'Copier le lien');
    if (labelEl && !labelEl.getAttribute('data-orig')) labelEl.setAttribute('data-orig', ORIGINAL);
    var done = false;
    function flash() {
      if (!labelEl) return;
      if (copyTimer) clearTimeout(copyTimer);
      labelEl.textContent = i18n('link_copied', 'Lien copié !');
      copyTimer = setTimeout(function () { labelEl.textContent = ORIGINAL; }, 2000);
    }
    function ok() { if (done) return; done = true; flash(); }
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
      } catch (e) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { fallback(); ok(); });
      setTimeout(function () { if (!done) { fallback(); ok(); } }, 600);
    } else {
      fallback(); ok();
    }
  }

  // Favori : cœurs natifs [data-amana-wishlist-button], gérés par assets/amana-wishlist.js
  // (stockage, état, suivi GA4 add_to_wishlist). Plus d'appel à l'app Swish.

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var root = t.closest('[data-qsc-content]'); // tiroir ou page /cart : les panneaux se cherchent dans le même rendu

    if (t.closest('[data-qsc-close]') || t.closest('[data-qsc-overlay]')) { e.preventDefault(); closeDrawer(); return; }

    var rm = t.closest('[data-qsc-remove]');
    if (rm) {
      e.preventDefault();
      var w = rm.closest('[data-qsc-line]');
      if (w && w.getAttribute('data-removing') !== '1') {
        var key = w.getAttribute('data-qsc-key');
        var remIt = stateItem(key, root); // GA4 : retrait (capturé avant le slide-out)
        if (remIt) track('remove_from_cart', { currency: (cartState(root) || {}).currency || 'EUR', value: remIt.final_line_price / 100, items: [gaItem(remIt)] });
        w.setAttribute('data-removing', '1');
        w.style.pointerEvents = 'none';
        w.style.transition = 'opacity .25s ease, transform .25s ease';
        w.style.opacity = '0';
        w.style.transform = 'translateX(24px)';
        var ch = {}; ch[key] = 0;
        setLines(ch);
      }
      return;
    }

    var qb = t.closest('[data-qsc-qty]');
    if (qb) {
      e.preventDefault();
      var w2 = qb.closest('[data-qsc-line]');
      if (w2) {
        var delta = parseInt(qb.getAttribute('data-qsc-qty'), 10);
        var cur = parseInt(w2.getAttribute('data-qsc-qty-current'), 10) || 1;
        var ch2 = {}; ch2[w2.getAttribute('data-qsc-key')] = Math.max(0, cur + delta);
        setLines(ch2);
      }
      return;
    }

    var ra = t.closest('[data-qsc-rec-add]');
    if (ra) {
      e.preventDefault();
      if (ra.getAttribute('aria-busy') === 'true') return; // anti double-clic
      ra.setAttribute('aria-busy', 'true');
      ra.disabled = true;
      // GA4 : clic sur une reco (l'add_to_cart sera émis par Shopify ; ici on mesure l'engagement avec la liste)
      var rcard = ra.closest('.qsc2-r-product');
      if (rcard) {
        var rT = rcard.querySelector('.qsc2-r-product__product-title span');
        var rP = rcard.querySelector('.qsc2-r-product__price');
        track('select_item', { item_list_id: 'drawer_recommendations', item_list_name: 'Pour sublimer votre sac', items: [{ item_id: ra.getAttribute('data-qsc-rec-add') || '', item_name: rT ? rT.textContent.trim() : '', price: priceFromText(rP && rP.textContent), quantity: 1 }] });
      }
      // Comme Qikify : remplacer le label par un spinner pendant l'ajout (le rendu restaure le bouton)
      while (ra.firstChild) ra.removeChild(ra.firstChild);
      var sp = document.createElement('span'); sp.className = 'qsc2-spinner'; ra.appendChild(sp);
      addToCart({ items: [{ id: parseInt(ra.getAttribute('data-qsc-rec-add'), 10), quantity: 1 }] });
      return;
    }

    if (t.closest('[data-qsc-promo-open]')) {
      e.preventDefault();
      var p = q('[data-qsc-promo-panel]', root); if (p) p.classList.remove('qsc2-sf-content--hide');
      var pi = q('[data-qsc-promo-input]', root);
      try { if (pi && !pi.value) pi.value = localStorage.getItem('stickycart-discount-code') || ''; } catch (err) {}
      return;
    }
    if (t.closest('[data-qsc-promo-close]')) { e.preventDefault(); var p2 = q('[data-qsc-promo-panel]', root); if (p2) p2.classList.add('qsc2-sf-content--hide'); return; }
    if (t.closest('[data-qsc-promo-save]')) {
      e.preventDefault();
      var inp3 = q('[data-qsc-promo-input]', root);
      var code = inp3 ? inp3.value.trim() : '';
      discountCode = code;
      try { localStorage.setItem('stickycart-discount-code', code); } catch (err) {}
      // Comme Qikify : applique la remise au panier via /cart/update.js (Shopify la calcule).
      var fd = new FormData(); fd.append('discount', code); fd.append('sections', SECTION);
      rawFetch(rootUrl() + 'cart/update.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (!renderFrom(j)) refresh(); })
        .catch(function () { refresh(); });
      return;
    }

    if (t.closest('[data-qsc-checkout]')) {
      e.preventDefault();
      window.location.href = '/checkout'; // la remise éventuelle est déjà appliquée au panier (cart/update.js)
      return;
    }

    // --- Tooltip "rappel valeur" (réassurance) : toggle au clic ; ferme au clic extérieur. Pas d'ID (le drawer est global) → pas de conflit avec le bloc identique de la page produit. ---
    var spTip = t.closest('[data-sp-tip-toggle]');
    if (spTip) {
      e.preventDefault();
      var spW = spTip.closest('.sp-tooltip-wrapper');
      var spWillOpen = spW && !spW.classList.contains('active');
      document.querySelectorAll('.sp-tooltip-wrapper.active').forEach(function (x) { x.classList.remove('active'); });
      if (spWillOpen) spW.classList.add('active');
      return;
    }
    if (!t.closest('.sp-tooltip-content')) {
      document.querySelectorAll('.sp-tooltip-wrapper.active').forEach(function (x) { x.classList.remove('active'); });
    }

    if (t.closest('[data-qsc-share-open]')) {
      e.preventDefault();
      if (!shareCart(root)) { // pas de partage natif (desktop) → ouvrir le panneau d'options
        var shp = q('[data-qsc-share-panel]', root);
        if (shp) shp.classList.remove('qsc2-sf-content--hide');
      }
      return;
    }
    if (t.closest('[data-qsc-share-close]')) {
      e.preventDefault();
      var sp2 = q('[data-qsc-share-panel]', root);
      if (sp2) sp2.classList.add('qsc2-sf-content--hide');
      return;
    }
    var shareOpt = t.closest('[data-qsc-share]');
    if (shareOpt) {
      e.preventDefault();
      shareVia(shareOpt.getAttribute('data-qsc-share'), shareOpt.querySelector('[data-qsc-copy-label]'), root);
      return;
    }

    // Liens vers /cart → tiroir (sauf sur la page /cart, qui n'a pas de tiroir : navigation normale).
    var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], [data-qsc-open]');
    if (cartLink && drawerEl() && !t.closest('[data-qsc-drawer]')) { e.preventDefault(); openDrawer(); refresh(); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeDrawer(); });

  // --- Upsell dustbag d'origine : cocher = ajoute la quantité manquante, décocher = retire toutes
  // les lignes de ce variant (par clé). L'état de la checkbox est recalculé en Liquid à chaque rendu.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-qsc-dustbag-input]')) return;
    var row = input.closest('[data-qsc-dustbag]');
    if (!row || row.classList.contains('is-busy')) return;
    var root = row.closest('[data-qsc-content]');
    var vid = parseInt(row.getAttribute('data-db-variant'), 10);
    var qty = parseInt(row.getAttribute('data-db-qty'), 10) || 1;
    var checked = input.checked;
    row.classList.add('is-busy');
    var done;
    if (checked) {
      done = addToCart({ items: [{ id: vid, quantity: qty }] });
    } else {
      var changes = {};
      ((cartState(root) || {}).items || []).forEach(function (it) { if (Number(it.variant_id) === vid) changes[it.key] = 0; });
      // GA4 : retrait (l'add_to_cart du cocher est émis par Shopify). Quantité retirée = ce qui était au panier.
      var dbPrice = parseFloat(row.getAttribute('data-db-price')) || 0;
      var dbIn = parseInt(row.getAttribute('data-db-in'), 10) || 1;
      track('remove_from_cart', { currency: 'EUR', value: dbPrice * dbIn, items: [{ item_id: String(vid), item_name: row.getAttribute('data-db-title') || "Le Dustbag d'origine", price: dbPrice, quantity: dbIn }] });
      done = setLines(changes);
    }
    done.then(function (ok) { if (ok === false) { input.checked = !checked; row.classList.remove('is-busy'); } });
  });

  // Ajout au panier : on prend le contrôle (clic ET submit, en capture) pour ouvrir le tiroir
  // + mettre un spinner sur le bouton. Garde __qscBusy pour ne pas traiter deux fois.
  function qscHandleAdd(form, btn, evt) {
    if (evt) { evt.preventDefault(); evt.stopPropagation(); }
    if (form.__qscBusy) return;
    // Anti-doublon sac (pièce unique) : si le variant est déjà au panier avec un prix unitaire
    // >= 50 € (heuristique sac d'auto-gift : entretien < 50 €, cadeaux 0 €), on n'envoie PAS le
    // add.js — feedback immédiat au lieu du 422 Shopify, et couvre sa fenêtre de course en rafale.
    var dupInp = form.querySelector('[name="id"]');
    var dupVid = dupInp && parseInt(dupInp.value, 10);
    var st = cartState();
    if (dupVid && st) {
      var g = gifts(), min = 5000 * (g ? g.rate() : 1);
      var dup = st.items.some(function (it) { return Number(it.variant_id) === dupVid && it.final_price >= min; });
      if (dup) {
        openDrawer();
        qscToast(i18n('toast_already', 'Cet article est déjà dans votre panier.'));
        return;
      }
    }
    form.__qscBusy = true;
    if (openDrawer()) showPending(form); // slide-in immédiat (comme Qikify) + ligne provisoire
    var restore = function () { form.__qscBusy = false; };
    if (btn && btn.getAttribute('data-qsc-adding') !== '1') {
      btn.setAttribute('data-qsc-adding', '1');
      var prevPos = btn.style.position, prevColor = btn.style.color, wasDisabled = btn.disabled;
      var textColor = getComputedStyle(btn).color; // couleur d'origine pour le spinner
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.color = 'transparent';
      btn.disabled = true;
      var sp = document.createElement('span');
      sp.className = 'qsc2-spinner';
      sp.style.cssText = 'position:absolute;top:50%;left:50%;margin:0;transform:translate(-50%,-50%);border-color:transparent ' + textColor + ' ' + textColor;
      btn.appendChild(sp);
      var prev = restore;
      restore = function () {
        if (sp.parentNode) sp.parentNode.removeChild(sp);
        btn.style.color = prevColor; btn.style.position = prevPos; btn.disabled = wasDisabled;
        btn.removeAttribute('data-qsc-adding');
        prev();
      };
    }
    addToCart(new FormData(form)).then(function () { setTimeout(restore, 350); }, restore);
  }

  // Clic sur le bouton ajouter (capture) — avant le JS du thème (sinon il navigue/ajax)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('button[name="add"], button[type="submit"], [data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    qscHandleAdd(form, btn, e);
  }, true);

  // Submit (capture) — fallback (touche Entrée, formulaires sans bouton type=submit)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') > -1) {
      qscHandleAdd(form, form.querySelector('button[name="add"], button[type="submit"], [data-add-to-cart]'), e);
    }
  }, true);

  // Signature du panier affiché (variant:quantité, même ordre que /cart.js) : auto-gift compare avec
  // /cart.js et rafraîchit si l'affichage est périmé.
  function signature() {
    var st = cartState();
    return st ? st.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') : null;
  }

  window.QscCart = { open: function () { refresh(openDrawer); }, close: closeDrawer, refresh: refresh, signature: signature };

})();
